import { createFileRoute } from '@tanstack/react-router'
import Haberler from '@/modules/haberler'

export const Route = createFileRoute('/_authenticated/haberler/')({
  component: Haberler,
})
